import { render, staticRenderFns } from "./ClienteCadastrado.vue?vue&type=template&id=0efced35"
import script from "./ClienteCadastrado.vue?vue&type=script&lang=js"
export * from "./ClienteCadastrado.vue?vue&type=script&lang=js"
import style0 from "./ClienteCadastrado.vue?vue&type=style&index=0&id=0efced35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports